import React from 'react';
import MobileFrame from './MobileFrame';

const MobileFintech: React.FC = () => {
  const transactions = [
    { label: 'Apple Store', cat: 'Tech', amount: '-89,00', icon: '◉', color: '#0A1929' },
    { label: 'Starbucks', cat: 'Resto', amount: '-5,40', icon: '◑', color: '#2E7D32' },
    { label: 'Salaire', cat: 'Revenu', amount: '+3 200', icon: '↓', color: 'var(--blue)' },
    { label: 'Netflix', cat: 'Abonnement', amount: '-15,99', icon: '▶', color: '#C62828' },
  ];

  return (
    <div style={{ padding: '1.5rem 0', background: 'transparent', display: 'flex', justifyContent: 'center' }}>
      <MobileFrame>
        <div style={{ paddingTop: '14px' }}>
          {/* Greeting */}
          <div style={{ marginBottom: '.6rem' }}>
            <div style={{ fontSize: '.5rem', color: 'var(--ink2)', fontFamily: "'Montserrat', sans-serif" }}>Bonjour,</div>
            <div style={{ fontSize: '.75rem', fontWeight: 600, color: 'var(--ink)', fontFamily: "'Cormorant Garamond', serif" }}>Amir M.</div>
          </div>

          {/* Card */}
          <div
            style={{
              background: 'linear-gradient(135deg, #0F2744 0%, #1A6FA8 100%)',
              borderRadius: '10px',
              padding: '.7rem .8rem',
              color: 'white',
              marginBottom: '.8rem',
              boxShadow: '0 10px 20px -8px rgba(15,39,68,.5)',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <div style={{
              position: 'absolute', top: '-20px', right: '-20px', width: '60px', height: '60px',
              background: 'radial-gradient(circle, rgba(184,146,42,.4), transparent 70%)'
            }} />
            <div style={{ fontSize: '.42rem', opacity: .7, letterSpacing: '.1em', fontFamily: "'Montserrat', sans-serif" }}>SOLDE</div>
            <div style={{ fontSize: '1.05rem', fontWeight: 600, fontFamily: "'Cormorant Garamond', serif", marginTop: '.1rem' }}>€12 847,20</div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'end', marginTop: '.5rem' }}>
              <div style={{ fontSize: '.45rem', letterSpacing: '.15em', fontFamily: "'Montserrat', sans-serif", opacity: .85 }}>•••• 4832</div>
              <div style={{
                fontSize: '.42rem', background: 'var(--gold)', color: '#0F2744',
                padding: '.1rem .3rem', borderRadius: '2px', fontWeight: 700, letterSpacing: '.1em'
              }}>VISA</div>
            </div>
          </div>

          {/* Mini chart */}
          <div style={{ marginBottom: '.7rem' }}>
            <div style={{ fontSize: '.45rem', color: 'var(--ink2)', letterSpacing: '.08em', textTransform: 'uppercase', marginBottom: '.3rem', fontFamily: "'Montserrat', sans-serif" }}>
              Dépenses 7j
            </div>
            <svg viewBox="0 0 180 30" style={{ width: '100%', height: '30px' }}>
              <defs>
                <linearGradient id="mFinGrad" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="var(--blue)" stopOpacity=".3" />
                  <stop offset="100%" stopColor="var(--blue)" stopOpacity="0" />
                </linearGradient>
              </defs>
              <path d="M 0 20 L 30 14 L 60 18 L 90 8 L 120 12 L 150 5 L 180 10 L 180 30 L 0 30 Z" fill="url(#mFinGrad)" />
              <path d="M 0 20 L 30 14 L 60 18 L 90 8 L 120 12 L 150 5 L 180 10" stroke="var(--blue)" strokeWidth="1.5" fill="none" />
            </svg>
          </div>

          {/* Transactions */}
          <div>
            <div style={{ fontSize: '.45rem', color: 'var(--ink2)', letterSpacing: '.08em', textTransform: 'uppercase', marginBottom: '.3rem', fontFamily: "'Montserrat', sans-serif" }}>Transactions</div>
            {transactions.map((t, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '.4rem', padding: '.3rem 0', borderBottom: i < transactions.length - 1 ? '1px solid var(--border)' : 'none' }}>
                <div style={{ width: '20px', height: '20px', borderRadius: '50%', background: `${t.color}18`, color: t.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.6rem', flexShrink: 0 }}>
                  {t.icon}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: '.52rem', fontWeight: 600, color: 'var(--ink)', fontFamily: "'Montserrat', sans-serif" }}>{t.label}</div>
                  <div style={{ fontSize: '.42rem', color: 'var(--ink2)', fontFamily: "'Montserrat', sans-serif" }}>{t.cat}</div>
                </div>
                <div style={{ fontSize: '.55rem', fontWeight: 700, color: t.amount.startsWith('+') ? '#2E7D32' : 'var(--ink)', fontFamily: "'Montserrat', sans-serif" }}>
                  {t.amount} €
                </div>
              </div>
            ))}
          </div>
        </div>
      </MobileFrame>
    </div>
  );
};

export default MobileFintech;
